export default "__VITE_ASSET__Brwo0tMJ__"